import { FC, ReactNode, useMemo } from 'react';

import { useRecoilValue } from 'recoil';

import {
  CalendarIcon,
  DashboadIcon,
  FinanceReportIcon,
  PatientListIcon,
  ReferralIcon
} from 'assets/icons';
import InboxNav from 'components/Navbar/InboxNav/InboxNav';
import { pagePaths } from 'config/pages';
import { PERMISSIONS } from 'constants/Permissions';
import { loginedUserDetails } from 'store/atoms';

const useNavBarConfig = () => {
  interface NavItem {
    title: string | ReactNode;
    icon?: FC<{ className?: string }>;
    path: string;
    customClass?: string;
    showSpacer?: boolean;
    permission?: string;
    testId?: string;
    hidden?: boolean;
  }

  const loginedUser = useRecoilValue(loginedUserDetails);

  const isSoaEnabled = useMemo(() => {
    return loginedUser?.clinic?.some((clinic) => clinic.isSOAEnabled);
  }, [loginedUser]);

  const getNavBarItems = () => {
    const navBarItems: Array<NavItem> = [
      {
        title: 'dashboard_button.dashboard',
        icon: DashboadIcon,
        path: pagePaths.dashboard,
        permission: PERMISSIONS?.DASHBOARD_PAGE,
        testId: 'sidebar-item-dashboard'
      },
      {
        title: 'patient_list_button.patient_list',
        icon: PatientListIcon,
        path: pagePaths.patientList,
        permission: PERMISSIONS?.PATIENT_LIST,
        testId: 'sidebar-item-patients-list'
      },
      {
        title: 'calendar_button.calendar',
        icon: CalendarIcon,
        path: pagePaths.calendar,
        permission: PERMISSIONS?.CALENDAR,
        testId: 'sidebar-item-calendar'
      },
      {
        title: <InboxNav />,
        path: pagePaths.inbox,
        permission: PERMISSIONS?.INBOX,
        testId: 'sidebar-item-inbox'
      },
      {
        title: 'referrals.referrals',
        icon: ReferralIcon,
        path: pagePaths.referrals,
        permission: PERMISSIONS?.REFERRAL,
        testId: 'sidebar-item-referrals'
      },
      {
        title: 'finance_report_button.finance_report',
        icon: FinanceReportIcon,
        path: pagePaths.financeReport,
        permission: PERMISSIONS?.FINANCE_TAB_VIEW,
        testId: 'finance',
        hidden: !isSoaEnabled
      }
    ];
    return navBarItems;
  };
  return { getNavBarItems };
};
export default useNavBarConfig;
